<app-toolbar #toolbar></app-toolbar>
<mat-divider></mat-divider>
<div class="pix-card">
  <h2>Pagamento via PIX</h2>

  @if (pago) {
    <div class="pix-confirmado">
      <mat-icon>check_circle</mat-icon>
      <p>Pagamento confirmado!</p>
    </div>
  } @else {
    <div class="qrcode-wrapper">
      <qrcode
        [qrdata]="pixCopiaECola"
        [width]="220"
        [errorCorrectionLevel]="'M'">
      </qrcode>
    </div>

    <div class="pix-code">
      <label for="codigoPix">Código PIX (copia e cola)</label>
      <textarea id="codigoPix" readonly>{{ pixCopiaECola }}</textarea>
    </div>

    <button class="btn-copiar" (click)="copiarCodigo()">
      Copiar Código
    </button>

    @if (expirado) {
      <div class="pix-expirado">
        <p>O tempo de espera para a confirmação do pagamento expirou. Deseja continuar aguardando?</p>
        <button class="btn-copiar" (click)="continuarAguardando()">
          Continuar aguardando
        </button>
      </div>
    }
  }
</div>
